import zaw from 'utils/zaw';
// TODO SIM(P69622130): uncomment once we can test CO fee in alpha
// import { toFloatInt } from 'helpers/NumberFormats';

const makeHeading = (singleBox, boxNum) => `Return Summary${!singleBox ? ` for Box ${boxNum}` : ''}`;

const makeTitle = items => {
  if (items.length !== 1) {
    return `${items.length} items`;
  }

  const { style, color = '', size = '' } = items[0];

  if (!color && !size) {
    return style;
  }

  return `${style} - ${color} ${size}`.trimEnd();
};

const makeTotals = (items, isZAWReturnsEnabled, zawPromotions, ordersMap) => {
  const totals = {
    subtotal: 0,
    promos: 0,
    zawSubsidies: 0,
    zawDiscounts: 0,
    otherPromos: 0,
    tax: 0,
    coloradoFee: 0,
    refundTotal: 0,
    total: 0
  };

  // TODO SIM(P69622130): uncomment once we can test CO fee in alpha
  // const uniqueOrdersForColoradoFeeCalculation = [];
  // const getColoradoFee = (ordersMap, orderId) => {
  //   if (uniqueOrdersForColoradoFeeCalculation.includes(orderId)) {
  //     return 0;
  //   }
  //   uniqueOrdersForColoradoFeeCalculation.push(orderId);

  //   const feeAsString = ordersMap[orderId]?.pricing?.retailDeliveryFee ?? '$0.00';
  //   return toFloatInt(feeAsString);
  // };

  items.forEach(({ ourPrice, promoAmount, taxAmount, orderId }) => {
    const containsZawPromos = zaw.promotionsAlreadyFetched(zawPromotions) && zaw.containsZawPromotions(zawPromotions);
    const shouldCalculateZawPromos = isZAWReturnsEnabled && containsZawPromos;
    const promosWithZawData = shouldCalculateZawPromos ? zaw.getPromosMergedWithZawDataForOrder(ordersMap[orderId], zawPromotions) : [];

    totals.subtotal += ourPrice;
    if (shouldCalculateZawPromos) {
      totals.zawSubsidies += zaw.getTotalSubsidyAmount(promosWithZawData);
      totals.zawDiscounts += zaw.getTotalDiscountAmount(promosWithZawData);
      totals.otherPromos = Math.abs(promoAmount) - (totals.zawSubsidies + totals.zawDiscounts);
    }
    totals.promos += promoAmount;
    totals.tax += taxAmount;
    // TODO SIM(P69622130): uncomment once we can test CO fee in alpha
    // totals.coloradoFee += getColoradoFee(ordersMap, orderId);
  });

  const { subtotal, tax, promos, coloradoFee } = totals;
  totals.refundTotal = subtotal + tax + promos;
  totals.total = totals.refundTotal + coloradoFee;
  return totals;
};

const combineBoxTotals = allBoxTotals =>
  allBoxTotals.reduce(
    (combined, boxTotals) => ({
      subtotal: combined.subtotal + boxTotals.subtotal,
      tax: combined.tax + boxTotals.tax,
      total: combined.total + boxTotals.total,
      refundTotal: combined.refundTotal + boxTotals.refundTotal,
      promos: combined.promos + boxTotals.promos,
      zawSubsidies: combined.zawSubsidies + boxTotals.zawSubsidies,
      zawDiscounts: combined.zawDiscounts + boxTotals.zawDiscounts,
      otherPromos: combined.otherPromos + boxTotals.otherPromos,
      coloradoFee: combined.coloradoFee + boxTotals.coloradoFee
    }),
    {
      subtotal: 0,
      tax: 0,
      total: 0,
      refundTotal: 0,
      promos: 0,
      zawSubsidies: 0,
      zawDiscounts: 0,
      otherPromos: 0,
      coloradoFee: 0
    }
  );

const createSummaryVisibility = (isZAWReturnsEnabled, ordersMap, items, totals) => {
  const isSingleItemReturnAndOrder = zaw.returnContainsOneItemFromSingleItemOrder(ordersMap, items);

  const showZawSubsidy = isZAWReturnsEnabled && isSingleItemReturnAndOrder && totals.zawSubsidies > 0;
  const showZawDiscount = isZAWReturnsEnabled && isSingleItemReturnAndOrder && totals.zawDiscounts > 0;
  const showOtherPromos = isZAWReturnsEnabled && isSingleItemReturnAndOrder && totals.otherPromos > 0;
  const showPromos = !showZawSubsidy && !showZawDiscount;
  const showColoradoFee = totals.coloradoFee > 0;
  const showZawSubsidyMessage = isZAWReturnsEnabled && totals.zawSubsidies > 0;

  return {
    zawSubsidy: showZawSubsidy,
    zawDiscount: showZawDiscount,
    otherPromos: showOtherPromos,
    promos: showPromos,
    coloradoFee: showColoradoFee,
    zawSubsidyMessage: showZawSubsidyMessage
  };
};

export default {
  makeHeading,
  makeTitle,
  makeTotals,
  combineBoxTotals,
  createSummaryVisibility
};
